import LoaderReviewersGrid from "./LoaderReviewersGrid"
import ReviewersGridItem from "./ReviewersGridItem"



export default function ReviewersGrid({ isLoading, reviewers }) {
    if (isLoading) {
      return <LoaderReviewersGrid />
    }
    if (reviewers)
      return (
        <div className="grid grid-cols-12 gap-2">
          {reviewers?.map((reviewer) => (
            <ReviewersGridItem
              key={reviewer.id}
              reviewer={reviewer}
            />
          ))}
        </div>
      )
  }